import { axiosIntance } from "./config";

export const getAllTeam = async () => {
  const response = await axiosIntance.get("/teams");
  return response.data;
};

export const getTeam = async (id) => {
  const response = await axiosIntance.get(`/teams/${id}`);
  return response.data;
};

export const createTeam = async (data) => {
  const response = await axiosIntance.post("/teams", data);
  return response.data;
};

export const updateTeam = async (id, payload) => {
  const response = await axiosIntance.put(`/teams/${id}`, payload);
  return response.data;
};

export const deleteTeam = async (id) => {
  const response = await axiosIntance.delete(`/teams/${id}`);
  return response.data;
};
